import React from 'react';
import Typography, { TypographyProps } from 'atoms/Typography/Typography';
import FeaturedIconCard, { FeaturedIconCardProps } from 'molecules/FeaturedIconCard/FeaturedIconCard';
import Grid from 'atoms/Layout/Grid/Grid';
import Stack from 'atoms/Layout/Stack/Stack';

export interface FeaturedIconListProps {
  title?: TypographyProps;
  featuredIconList: FeaturedIconCardProps[];
}

const FeaturedIconList = ({ title, featuredIconList }: FeaturedIconListProps): JSX.Element => (
  <Grid totalColumns={1}>
    <Stack
      direction='column'
      gap='spacing-4xl'
      justify='flex-start'
      align='flex-start'
    >
      {title && (
        <Stack
          justify='flex-start'
          align='flex-start'
        >
          <Typography {...title} />
        </Stack>
      )}

      <Grid
        totalColumns={4}
        totalColumnsLg={2}
        totalColumnsSm={1}
        gap='spacing-3xl'
      >
        {featuredIconList.map((item, index) => (
          <FeaturedIconCard
            key={index}
            {...item}
          />
        ))}
      </Grid>
    </Stack>
  </Grid>
);

export default FeaturedIconList;
